import HeaderLogo from './HeaderLogo';

export default HeaderLogo;
